<template class="main-content">
    <div>
        <!-- Header Start -->

        <Header type="1" />

        <!-- Header Close -->

        <div class="main-wrapper">
            <!-- Slider Start -->
            <section class="slider">
                <div class="container-wrapper container-pos">
                    <div class="rowContainer">
                      <div class="block">
                        <h2
                          class="d-block mb-3 text-white text-capitalize"
                        >
                          {{ $t("l.home.mandate") }}
                          {{ $t("l.home.mandateSec") }}
                        </h2>
                        <!-- <span class="d-block mb-3 text-white text-capitalize"
          >智能交易触达更多客户群体<br />推动智能交易在中国金融市场更快的普及<br />提高中国金融市场投资效率与质量
        </span> -->
                        <!--                                <span-->
                        <!--                                    style="fontsize: 24px"-->
                        <!--                                    class="-->
                        <!--                                        d-block-->
                        <!--                                        mb-3-->
                        <!--                                        text-white text-capitalize-->
                        <!--                                    "-->
                        <!--                                    >{{ $t("l.home.mandateSec") }}-->
                        <!--                                </span>-->

                        <h1 class="animated fadeInUp mb-5"></h1>
                      </div>
<!--                        <div class="col-lg-10 col-md-10">-->
<!--                        </div>-->
                    </div>
                </div>
            </section>
            <!-- Section Intro Start -->
            <section class="section intro" style="background: rgba(0, 0, 0, 0.02);">
                <div class="container-wrapper">

                  <div class="section-title">
                    <h4 class="h4 text-color container-title mt-3">
                      {{ $t("l.home.introTitle") }}
                    </h4>
                    <!-- <h2 class="mt-3 content-title">大数据服务平台</h2> -->
                    <p class="text-indent">
                      {{ $t("l.home.intro") }}
                    </p>
                  </div>

                  <div class="section-title select-bom">
                    <h4 class="h4 text-color container-title mt-3">
                      {{ $t("l.home.clients") }}
                    </h4>
                  </div>
                  <div class="threeImg">
                    <div class="Containt">
                      <ul
                        :style="{
                                    left: calleft + 'px',
                                    width: widthData + 'px',
                                }"
                        v-on:mouseover="stopmove()"
                        v-on:mouseout="move()"
                        class="imgBoxoul"
                      >
                        <li
                          v-for="(item, index) in dataList"
                          :key="index"
                          ref="lis"
                        >
                          <div >
                            <template v-for="(item1, index) in item">
                              <img
                                :src="item1.thumb"
                                class="
                                            rounded
                                            img-fluid
                                            w-100
                                            honor-img
                                        "
                                @click.self="showBigImage($event)"
                                alt=""
                              />
                            </template>
                          </div>

                        </li>
                      </ul>
                    </div>
                  </div>
                  <!-- 显示放大的图片 -->
                  <BigImg
                    :visible="photoVisible"
                    :url="BigImgUrl"
                    @closeClick="() => (photoVisible = false)"
                  />
                </div>
            </section>
            <!-- footer Start -->
            <Footer />
        </div>
    </div>
</template>
 <!-- Main jQuery -->
<script src="../plugins/jquery/jquery.js"></script>
<script src="./assets/js/contact.js"></script>
<!-- Bootstrap 4.3.1 -->
<script src="../plugins/bootstrap/js/popper.js"></script>
<script src="../plugins/bootstrap/js/bootstrap.min.js"></script>
<!--  Magnific Popup-->
<script src="../plugins/magnific-popup/dist/jquery.magnific-popup.min.js"></script>
<!-- Slick Slider -->
<script src="../plugins/slick-carousel/slick/slick.min.js"></script>
<!-- Counterup -->
<script src="../plugins/counterup/jquery.waypoints.min.js"></script>
<script src="../plugins/counterup/jquery.counterup.min.js"></script>

<!-- Google Map -->
<script src="../plugins/google-map/map.js"></script>
<script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyAkeLMlsiwzp6b3Gnaxd86lvakimwGA6UA&callback=initMap"></script>

<script src="./assets/js/script.js"></script>
<script>
// import '../../plugins/jquery/jquery';
// import '../assets/js/contact';
import BigImg from "../components/BigImg";
import Footer from "../components/Footer";
import Header from "../components/Header";
export default {
    name: "Home",
    components: {
        Footer,
        Header,
        BigImg
    },
    data() {
        return {
            msg: "Welcome to Your Vue.js App",
          timer: undefined,
          offset: 0,
          dataList: [
            [
              {
                id: 1,
                thumb: require("../assets/images/newImgs/cooperation1.png"),
              },
              {
                id: 2,
                thumb: require("../assets/images/newImgs/cooperation2.png"),
              },
              {
                id: 3,
                thumb: require("../assets/images/newImgs/cooperation3.png"),
              },
            ],
            [

              {
                id: 4,
                thumb: require("../assets/images/newImgs/cooperation4.png"),
              },
              {
                id: 5,
                thumb: require("../assets/images/newImgs/cooperation5.png"),
              },
              {
                id: 6,
                thumb: require("../assets/images/newImgs/cooperation6.png"),
              },
            ],
            [
              {
                id: 7,
                thumb: require("../assets/images/newImgs/cooperation7.png"),
              },
              {
                id: 8,
                thumb: require("../assets/images/newImgs/cooperation8.png"),
              },
              {
                id: 9,
                thumb: require("../assets/images/newImgs/cooperation9.png"),
              },
            ],
            [
              {
                id: 10,
                thumb: require("../assets/images/newImgs/cooperation10.png"),
              },
              {
                id: 11,
                thumb: require("../assets/images/newImgs/cooperation11.png"),
              },
              {
                id: 12,
                thumb: require("../assets/images/newImgs/cooperation12.png"),
              },
            ],
            [
              {
                id: 13,
                thumb: require("../assets/images/newImgs/cooperation13.png"),
              },
              {
                id: 14,
                thumb: require("../assets/images/newImgs/cooperation14.png"),
              },
              {
                id: 15,
                thumb: require("../assets/images/newImgs/cooperation15.png"),
              },
            ],
            [
              {
                id: 30,
                thumb: require("../assets/images/newImgs/cooperation1.png"),
              },
              {
                id: 31,
                thumb: require("../assets/images/newImgs/cooperation2.png"),
              },
              {
                id: 32,
                thumb: require("../assets/images/newImgs/cooperation3.png"),
              },
            ],
            [

              {
                id: 33,
                thumb: require("../assets/images/newImgs/cooperation4.png"),
              },
              {
                id: 34,
                thumb: require("../assets/images/newImgs/cooperation5.png"),
              },
              {
                id: 35,
                thumb: require("../assets/images/newImgs/cooperation6.png"),
              },
            ],
            [
              {
                id: 36,
                thumb: require("../assets/images/newImgs/cooperation7.png"),
              },
              {
                id: 37,
                thumb: require("../assets/images/newImgs/cooperation8.png"),
              },
              {
                id: 38,
                thumb: require("../assets/images/newImgs/cooperation9.png"),
              },
            ],
            [
              {
                id: 39,
                thumb: require("../assets/images/newImgs/cooperation10.png"),
              },
              {
                id: 40,
                thumb: require("../assets/images/newImgs/cooperation11.png"),
              },
              {
                id: 41,
                thumb: require("../assets/images/newImgs/cooperation12.png"),
              },
            ],
            [
              {
                id: 42,
                thumb: require("../assets/images/newImgs/cooperation13.png"),
              },
              {
                id: 43,
                thumb: require("../assets/images/newImgs/cooperation14.png"),
              },
              {
                id: 44,
                thumb: require("../assets/images/newImgs/cooperation15.png"),
              },
            ]
          ],

          calleft: 0,
          speed: 1,
          photoVisible: false,
          BigImgUrl: "",
        };
    },
    mounted() {
        console.log(navigator);
        // this.$i18n.locale = navigator.language;
        // this.systemLanguage = navigator.language;
        localStorage.setItem("languageSet", navigator.language);
    },
    methods: {
      //移动
      move() {
        console.log('移动')
        this.timer = setInterval(this.starmove, 20);
      },
      //开始移动
      starmove() {
        this.calleft -= 1.2; //*this.speed
        if (this.calleft <= -1150) {
          this.calleft = 0;
        }
      },
      //鼠标悬停时停止移动
      stopmove() {
        clearInterval(this.timer);
      },
      // 放大图片
      showBigImage(e) {
        if (e !== "") {
          console.log('放大图片', e.currentTarget.src)
          this.photoVisible = true;
          this.BigImgUrl = e.currentTarget.src;
        }
      },
      clearIntervalAll() {
        let endTid = setTimeout(function () {});
        for (let i = 0; i <= endTid; i++) {
          clearInterval(i);
        }
      },
        jumpHome() {
            this.$router.push("");
        },
        jumpAbout() {
            this.$router.push("/about");
        },
        jumpContact() {
            this.$router.push("/contact");
        },
        jumpAssistant() {
            this.$router.push("/assistant");
        },
        jumpInvestment() {
            this.$router.push("/investment");
        },
    },

  created() {
    this.move();
  },
  computed: {
    widthData() {
      return 400 * Number(this.dataList.length * 2);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
/* @import "../../plugins/bootstrap/css/bootstrap.min.css";
@import "../../plugins/themify/css/themify-icons.css";
@import "../../plugins/fontawesome/css/all.css";
@import "../../plugins/magnific-popup/dist/magnific-popup.css";
@import "../../plugins/slick-carousel/slick/slick.css";
@import "../../plugins/slick-carousel/slick/slick-theme.css";
@import "../assets/css/style.css"; */
#navbar {
    color: #fff;
    background: #222328;
    -webkit-box-shadow: 0 1px 2px rgb(0 0 0 / 5%);
    box-shadow: 0 1px 2px rgb(0 0 0 / 5%);
}
.section-title p[data-v-7eb2bc79] {
    color: #666;
    font-family: "Microsoft YaHei";
    font-size: 20px;
}

.container-wrapper {
  text-align: center;
  width: 1200px;
  position: relative;
  margin:0 auto;
}
.text-indent {
  word-break: break-all;
    text-indent: 40px;
  text-align: left;
  font-size: 26px !important;
}

.threeImg {
  position: relative;
  width: 1000px;
  margin:0 auto;
}

.threeImg .Containt ul {
  margin: 0 auto;
  width: 2400px;
  position: absolute;
  left: 0px;
  cursor: pointer;
  height: 100%;
  z-index: 10;
}

.threeImg .Containt ul li {
  float: left;
  width: 220px;
  /*height: 260px;*/
  margin-right: 20px;
  border-radius: 10px;
  overflow: hidden;
}

.threeImg .Containt ul li img {
  width: 100%;
  /* height: 263px; */
  margin-bottom:60px;
}

.Containt {
  position: relative;
  /*padding: 60px 0;*/
  overflow-y: auto;
  /*width: 1200px;*/
  height: 330px;
  overflow: hidden;
  margin: 0 auto;
}

.honor-img {
  /*height: 260px;*/
  object-fit: contain;
}
.main-wrapper{
  .container{
    .rowContainer{
      margin: 0 auto;
      justify-content: center;
    }
    .text-capitalize{
      font-size: 3rem;
    }
  }
}

.container-pos{
  position: absolute;
  transform:translate(-50%,-50%);
  left:50%;
  top:50%;
}
.select-bom{
  margin-bottom:60px;
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue